module.exports = __webpack_public_path__ + "img/SignUp.3b6dacb9.svg";